import React from "react";
import { motion } from "framer-motion";
import musicNoteIcon from "../../assets/musicIcon.png";
import likePinkIcon from "../../assets/liked.png"; // ✅ Local asset
import dislikeIcon from "../../assets/dislike.png";

import { FiZap, FiCloudRain } from "react-icons/fi";

const SwipeIntroModal = ({ onClose, isLoading }) => {
  // ✅ 2. Define the pulsing animation for the icons
  const iconPulse = {
    scale: [1, 1.1, 1],
    transition: { repeat: Infinity, duration: 2, ease: "easeInOut" }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ 
        opacity: 0, 
        scale: 0, 
        x: -140, 
        y: -280,
        filter: "blur(10px)" 
      }}
      transition={{ duration: 0.4, ease: [0.32, 0, 0.67, 0] }}
      className="fixed inset-0 bg-black/80 backdrop-blur-md z-30 flex items-center justify-center px-6 cursor-pointer"
      onClick={!isLoading ? onClose : null}
    >
      <div className="relative flex flex-col items-center w-full max-w-sm text-center">
        
        {/* Header Text */}
        <motion.div 
          initial={{ y: -20 }}
          animate={{ y: 0 }}
          className="mb-12"
        >
          <h2 className="text-[#ff00cc] text-[10px] font-black uppercase tracking-[0.4em] mb-2">
            Gesture Guide
          </h2>
          <p className="text-white text-2xl font-black italic tracking-tighter">
            Rate, Earn & Discover
          </p>
        </motion.div>

        {/* Gesture Interface */}
        <div className="relative w-72 h-72 flex items-center justify-center">
          
          {/* Animated Background Rings */}
          <div className="absolute inset-0 border border-white/5 rounded-full" />
          <div className="absolute inset-8 border border-white/10 rounded-full" />

          {/* TOP: Next */}
          <div className="absolute top-0 flex flex-col items-center">
            <motion.span 
              animate={{ y: [0, -5, 0] }}
              transition={{ repeat: Infinity, duration: 1.5 }}
              className="text-[10px] font-black uppercase tracking-widest text-white/40 mb-2"
            >
              Next
            </motion.span>
            <div className="w-1 h-4 bg-gradient-to-b from-[#ff00cc] to-transparent rounded-full" />
          </div>

          {/* BOTTOM: Previous */}
          <div className="absolute bottom-0 flex flex-col items-center">
            <div className="w-1 h-4 bg-gradient-to-t from-white/20 to-transparent rounded-full mb-2" />
            <span className="text-[10px] font-black uppercase tracking-widest text-white/40">
              Previous
            </span>
          </div>

          {/* ✅ LEFT: MODERN NOT ICON (SVG with Gradient) */}
          <motion.div 
            animate={iconPulse} 
            className="absolute left-[-30px] flex items-center gap-2"
          >
            <div className="flex flex-col items-center gap-1">
              <img 
                src={dislikeIcon} 
                alt="Not" 
                className="w-10 h-10 opacity-90 transition-all" 
              />
              <span className="text-[11px] font-black uppercase tracking-widest text-blue-400 drop-shadow-[0_0_8px_rgba(59,130,246,0.6)]">
                NOT
              </span>
            </div>
            <div className="h-1 w-6 bg-white/10 rounded-full" />
          </motion.div>

          {/* ✅ RIGHT: MODERN HOT ICON (SVG with Gradient & Glow) */}
          <motion.div 
            animate={iconPulse} 
            className="absolute right-[-30px] flex items-center gap-2"
          >
            <div className="h-1 w-6 bg-[#ff00cc]/30 rounded-full shadow-[0_0_10px_#ff00cc]" />
            <div className="flex flex-col items-center gap-1">
              <img 
                src={likePinkIcon} 
                alt="Hot" 
                className="w-12 h-12 drop-shadow-[0_0_15px_rgba(255,0,204,0.8)]" 
              />
              <span className="text-[11px] font-black uppercase tracking-widest text-[#ff00cc] drop-shadow-[0_0_8px_rgba(255,0,204,0.8)]">
                HOT
              </span>
            </div>
          </motion.div>

          {/* CENTER: Tap Area */}
          <motion.div 
            className="w-32 h-32 bg-white/10 backdrop-blur-md border border-white/20 rounded-full flex flex-col items-center justify-center shadow-2xl"
          >
            {isLoading ? (
              <>
                {/* 🌀 Modern Spinner inside the modal */}
                <div className="w-6 h-6 border-2 border-[#ff00cc] border-t-transparent rounded-full animate-spin mb-2" />
                <span className="text-[8px] font-black uppercase tracking-widest text-[#ff00cc] animate-pulse">
                  Building List...
                </span>
              </>
            ) : (
              <>
                <img src={musicNoteIcon} alt="Music" className="w-5 h-5 mb-2 brightness-200" />
                <span className="text-[9px] font-black uppercase tracking-widest text-white">
                  Tap to Play
                </span>
              </>
            )}
          </motion.div>

        </div>

        {/* Footer Dismiss Text */}
        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="mt-16 text-white text-[9px] font-bold uppercase tracking-[0.2em]"
        >
          {isLoading ? "Please wait while we sync..." : "Tap anywhere to start"}
        </motion.p>

      </div>
    </motion.div>
  );
};

export default SwipeIntroModal;